export default "__VITE_ASSET__y3D44Lw7__"